// assets
import CalendarTodayTwoTone from '@mui/icons-material/CalendarTodayTwoTone';

// ==============================|| OVERRIDES - DATE PICKER ||============================== //

export default function DatePicker() {
  return {
    MuiDatePicker: {
      defaultProps: {
        slots: { openPickerIcon: () => <CalendarTodayTwoTone /> },
        // Firefox 52 (Windows XP target) doesn't support the `pointer` media feature, so MUI's
        // auto desktop/mobile detection falls back to the mobile modal picker on every machine —
        // whose click-outside handling crashes there (Node.contains). Force desktop mode always;
        // these are clinic desktop PCs with mouse/keyboard, not touchscreens.
        desktopModeMediaQuery: '@media (min-width: 0px)'
      }
    }
  };
}
